import createAsyncAction from 'shared/utils/createAsyncAction';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAction from './';
import * as services from '../services/getAttachments';


export const GET_CURRENT_CONSULTATION_MEDIA = createAsyncAction(createAction('GET_CURRENT_CONSULTATION_MEDIA'));

export const getCurrentConsultationMedia = () => (dispatch, getState) => {
  const state = getState();
  const { appointmentId } = state.appointmentInfo.currentAppointment;

  dispatch({ type: GET_CURRENT_CONSULTATION_MEDIA.pending });

  const apiCallParams = {
    query: services.GET_ATTACHMENTS,
    fetchPolicy: 'no-cache',
    variables: { appointmentId },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { appointment: { attachments } } }) => {
      dispatch({
        type: GET_CURRENT_CONSULTATION_MEDIA.success,
        payload: {
          attachments: attachments || [],
          appointmentId,
        },
      });
    })
    .catch((err) => dispatch(errorAction(GET_CURRENT_CONSULTATION_MEDIA.failure, err)));
};
